import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Form from "react-bootstrap/Form";
import axios from "axios";
//Hooks
import { useAuthContext } from "../../Hooks/useAuthContext";

// Libraries
import AvatarEditor from 'react-avatar-editor'

// Images
import profile from "../../Images/profile.png"




export default function AvatarEditorComponent({ onChange, profileImage }) {

    const [picture, setPicture] = useState({
        cropperOpen: false,
        img: null,
        croppedImg: profile,
        zoom: 2,
    });
    var editor = "";



    useEffect(() => {
        setPicture({
            ...picture,
            croppedImg: profileImage ? profileImage : profile,
        });
    },[profileImage]);
    


    const handleProfileUpload = (e) => {
        console.log("image uploaded")
        let url = URL.createObjectURL(e.target.files[0]);
        setPicture({
            ...picture,
            img: url,
            cropperOpen: true
        });
    };

    const handleSave = (e) => {
        console.log("saving")
        if (setEditorRef) {
            const canvasScaled = editor.getImageScaledToCanvas();
            const croppedImg = canvasScaled.toDataURL();

            setPicture({
                ...picture,
                img: null,
                cropperOpen: false,
                croppedImg: croppedImg
            });

            onChange("profileImage", croppedImg);
        }
    };

    const setEditorRef = (ed) => {
        editor = ed;
        ;
    };

    const handleSlider = (event) => {
        console.log("handle slider", event.target.value)
        setPicture({
            ...picture,
            zoom: event.target.value
        });
    };



    if (picture.cropperOpen) {
        return (
            <div>
                <AvatarEditor
                    ref={setEditorRef}
                    image={picture.img}
                    width={500}
                    height={500}
                    border={0}
                    borderRadius={10}
                    color={[255, 255, 255, 0.6]} // RGBA
                    scale={picture.zoom}
                    rotate={0}
                    style={{
                        width: "100%",
                        height: "auto"
                    }}
                />
                <div className="row">
                    <div className="col-10">
                        <label>Zoom</label>
                        <Form.Range
                            value={picture.zoom}
                            min={1}
                            max={10}
                            step={0.1}
                                onChange={handleSlider} />
                    </div>
                    <div className="col-2">
                        <button onClick={handleSave} className="btn btn-primary">Save</button>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div>
                <img src={picture.croppedImg} style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: 10
                }} />
                <input type="file" accept="image/*" onChange={handleProfileUpload} />
            </div>
            
        )
    }


    
}


